import { getCharMinMessage } from '../../../../utils/formValidation/errorMessageFunctions';

export const MIN_NOTES = 5;

export const validateNotes = (notes, errors) => {
    if (!notes || notes.length < MIN_NOTES) {
        return {
            ...errors,
            notes: { error: true, message: getCharMinMessage('Notes', MIN_NOTES) }
        };
    }
    return errors;
};
